// Cross-route handoff for "Open in custom query": Analysis stashes a stored
// query's SPARQL here and navigates to Queries, which picks it up and clears it.
// Same $state-module pattern as partnerDraft.

export const queryDraft = $state({ sparql: null });
